import $ from 'jquery';
import {curry} from 'ramda';
import isEmail from 'validator/lib/isEmail';

// validate :: String -> (String -> Boolean) -> Element -> String
const validate = curry((errorMessage, testValue, el) => {
    const $el = $(el);
    const value = $el.get(0).hasAttribute('contenteditable') ? $el.text() : $el.val();
    const valid = testValue(value);
    const message = $el.data('message') || errorMessage;

    $el.sdaToggleError(message, !valid);

    return valid;
});

// rxTest :: RegEx -> String -> Boolean
const rxTest = rx => value => (value ? rx.test(value) : true);

// required :: Element -> Boolean
export const required = validate('required', value => !!value);

// minLength :: Element -> Boolean
export const minLength = el => {
    const $el = $(el);
    const length = $el.data('minlength') || $el.attr('minlength');

    return validate(`min length ${length}`, value => value.trim().length >= length, el);
};

// maxLength :: Element -> Boolean
export const maxLength = el => {
    const $el = $(el);
    const length = $el.data('maxlength') || $el.attr('maxlength');

    return validate(`max length ${length}`, value => value.trim().length <= length, el);
};

// isUrl :: String -> Boolean
export const isUrl = rxTest(/^https?:\/\/[^/]+\.[^/]+\/?.*/i);

// Url :: Element -> Boolean
export const url = validate('invalid url format', isUrl);

// facebookUrl :: Element -> Boolean
export const facebookUrl = validate('invalid Facebook url', rxTest(/^https:\/\/(www\.)?facebook\.com/i));

// twitterUrl :: Element -> Boolean
export const twitterUrl = validate('invalid Twitter/X url', rxTest(/^https:\/\/(www\.)?(twitter\.com|x\.com)/i));

// instagramUrl :: Element -> Boolean
export const instagramUrl = validate('invalid Instagram url', rxTest(/^https:\/\/(www\.)?instagram\.com/i));

// pinterestUrl :: Element -> Boolean
export const pinterestUrl = validate('invalid Pinterest url', rxTest(/^https:\/\/([\w\d]*\.)?pinterest\.com/i));

// googlePlusUrl :: Element -> Boolean
export const googlePlusUrl = validate('invalid Google Plus url', rxTest(/^https:\/\/plus\.google\.com/i));
// threadsUrl :: Element -> Boolean
export const threadsUrl = validate('invalid Threads url', rxTest(/^https:\/\/(www\.)?threads\.net/i));

// tikTokUrl :: Element -> Boolean
export const tikTokUrl = validate('invalid TikTok url', rxTest(/^https:\/\/(www\.)?tiktok\.com/i));

// linkedinUrl :: Element -> Boolean
export const linkedinUrl = validate('invalid Linkedin url', rxTest(/^https:\/\/(www\.)?linkedin\.com/i));

// youtubeChannelUrl :: Element -> Boolean
export const youtubeChannelUrl = validate(
    'invalid Youtube Channel url',
    rxTest(/^https:\/\/(www\.)?youtube\.com\/[\w\d]{1,20}/i),
);

// tel :: Element -> Boolean
export const tel = validate(
    'invalid phone number format',
    rxTest(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/),
);

// currency :: Element -> Boolean
export const currency = validate('invalid currency format', rxTest(/^\$?\d+(,|\.)?\d*$/));

// age :: Element -> Boolean
export const age = validate('invalid age format', rxTest(/^(\d+)(-(\d+)|\+)?$/));

// alphaNumeric :: Element -> Boolean
export const alphaNumeric = validate('invalid format', rxTest(/^[\d\w]+$/i));

// email :: Element -> Boolean
export const email = validate('invalid email format', value => (value ? isEmail(value) : true));
